<template>
  <v-container fluid style="height:100%" pa-0 ma-0 class="new-order">
    <v-row no-gutters>
      <v-col cols="12" style="margin-top:60px" class="pl-3" v-if="showInstructions">
          <div style="font-size:15px;" class="pb-3">Tilauksen täyttö ohjeet. </div>
          <ol style="font-size:13px;">
            <li>
              Valitse tilaustyyppi. Sovituspaketeille on luotu valmiita vaihtoehtoa, joista voit valita yhden per tilaus.
            </li>
            <li>
              Mikäli kysessä on lisätilause olemassa olevaan tilaukseen, hae tilaus kenttään "Valitse tästä olemassa oleva tilaus". Voit hakea yrityksen nimellä.
              Jos valitset olemassa olevan tilauksen, tilauksen tiedot päivittyvät automaattisesti. Voit halutessasi päivittää yrityksen, kontaktin tietoja.
            </li>
            <li>Etsi "Valitse olemassa oleva asiakas" kentästä tilaava yritys. Jos löydät nimen, niin valitse yritys ja vierellä olevat kentät täyttyvät automaattisesti. Voit tarvittaessa korjata tietoja, jolloin asiakastiedot päivittyvät asiakasrekisteriin.
              Jos et löydä yritystä, niin jätä "Etsi yrityksiä" kenttä valitsematta ja täytä yrityksen tiedot. Pakolliset kentät ovat yrityksen nimi, toimitusosoite, postikoodi, toimipaikka, maa, vedoksille sähköposti (jos kyseessä on merkkaustuote).

            </li>
            <li>Valitse kontakti kentästä "Valitse kontakti". Jos et löydä olemassa olevaa kontaktia yritykselle, niin täytä tiedot kontaktin tiedot. Pakolliset kentät ovat etunimi, sukunimi, tilaajan puhelinnumero, tilaajan sähköpostiosoite.
            </li>
            <li>
              Jos haluat lisätä lisätietoja tilauksesta, voit lisätä ne "Tilauksessa muuta huomioitavaa" kenttään.
            </li>
            <li>
              Valitse tuote tilaukseen valitsemalla tuote "Etsi tuotteita" kentästä. Tuotetiedot täyttävyt automaattisesti.  
            </li>
            <li>
              Täytä tuotteelle vähintään ne tiedot, jotka on merkattu tähdellä.
            </li>
          </ol>
          
      </v-col>
    </v-row>
    <v-row no-gutters class="pa-4" v-if="!loaded">
      <v-col cols="12" offset-sm3 mt-3 class="text-center mt-15 pt-10" >
        <div style="color:#156CF4;"><b>Tietoja ladataan...</b></div>
        <div class="lds-facebook"><div></div><div></div><div></div></div>
      </v-col>
      
    </v-row>
    <v-row no-gutters class="pa-4" v-if="loaded">
      <v-row no-gutters class="hidden-md-and-up  my-5">
        <v-col cols="8">
          
          <v-btn 
            class="add-button avecor-button-global"
            @click="showInstructions = !showInstructions"
          >
            {{showInstructions ? "Sulje ohjeet" : "Näytä ohjeet"}}
          </v-btn>
          <v-btn 
            class="add-button avecor-button-global"
            @click="resetOrder"
          >
            Tyhjennä
          </v-btn>
          <v-btn 
            class="add-button avecor-button-global"
            @click="resendConfirmantionEmail"
            v-if="selectedExistingOrderId !== ''"
          >
            Lähetä vahvistusviestit uudestaan
          </v-btn>
        </v-col>
        <v-col cols="4" class="text-right">
          <v-btn 
            color="success"
            tile
            @click="validateAndCreateOrder"
          >
            Lähetä tilaus
          </v-btn>
        </v-col>
      </v-row>
      <div class="hidden-sm-and-down  my-3">
        <div style="position:fixed; right:10px; top:65px; color:white;z-index:500">
          <v-btn 
            v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'"
            class="add-button avecor-button-global"
            @click="$clipboard(getWeeksWithDates)"
          >
            Copy weeks
          </v-btn>
        <v-btn 
          style=""
          class="add-button avecor-button-global"
          @click="showInstructions = !showInstructions"
        >
          {{showInstructions ? "Sulje ohjeet" : "Näytä ohjeet"}}
        </v-btn>
        <v-btn 
          class="add-button avecor-button-global"
          @click="resendConfirmantionEmail"
          v-if="selectedExistingOrderId !== ''"
        >
          Lähetä vahvistusviesti uudestaan
        </v-btn>
        <v-btn 
          class="add-button avecor-button-global"
          @click="resetOrder"
        >
          Tyhjennä
        </v-btn>
        <v-btn 
          color="success"
          class="add-button"
          style="color:#FFF !important;"
          tile
          @click="validateAndCreateOrder"
        >
          Lähetä tilaus
        </v-btn>
        </div>
      </div>
      
      <v-row no-gutters style="width:100%">
        <v-col cols="12" md="12" class="mb-5" >
          <v-radio-group
            v-model="typeOfOrder"
            @change="errors.samplePackage = ''"
            row
            class="avecor-radio-group mt-0"
          >
            <template v-slot:label>
              <div class="mr-2">Valitse <strong>tilaustyyppi</strong></div>
            </template>
            <v-radio
              label="Normaali tilaus"
              value="normal"
            ></v-radio>
            <v-radio
              label="Sovituspaketti asiakkaille"
              value="sample"
            ></v-radio>
          </v-radio-group>
          <div style="padding-top:10px;font-style:italic;font-size:12px;">Tilatessasi mallikappaleita itsellesi, valitse normaali tilaus ja yritykseksi Avecor ja kontaktiksi oma nimi!</div>
        </v-col>  

        <v-col cols="12" md="4" >
          <v-autocomplete
            v-model="selectedExistingOrderId"
            :items="getOrders"
            autocomplete="off"
            label="Valitse tästä olemassa oleva tilaus mikäli kyseessä on lisätilaus. Vain tilauksille, joita ei vielä käsitelty."
            hint=""
            placeholder=" "
            item-text="text"
            item-value="value"
            @change="existingOrderFieldChanged"
            chips
          >
            <template v-slot:selection="data">
              <v-chip
                :input-value="data.selected"
                close
                small
                solo
                class="chip--select-multi"
                @click:close="removeExistingOrderSelection()"
              >
                {{ data.item.text.substr(0,500) }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row no-gutters style="width:100%">
        <v-col cols="6" md="2" class="pr-3" >
          <v-autocomplete
            :disabled="selectedExistingOrderId ? true : false"
            v-model="selectedCompanyId"
            autocomplete="off"
            :items="getCompanies"
            label="Valitse olemassa oleva asiakas"
            placeholder="  "
            item-text="text"
            item-value="value"
            @change="companyFieldChanged"
          >
            <template v-slot:selection="data">
              <v-chip
                :input-value="data.selected"
                close
                small
                solo
                class="chip--select-multi"
                @click:close="removeCompanySelection()"
              >
                {{ data.item.text.substr(0,20) }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="6" md="2" class="pr-3">
          <v-text-field
            label="Yrityksen nimi*"
            placeholder=" "
            :error-messages="errors.companyName"
            @blur="fieldUpdated('companyName')"
            @keyup="fieldUpdated('companyName')"
            v-model="companyName" />
        </v-col>
        <v-col cols="6" md="1" class="pr-3">
          <v-text-field
            label="Y-tunnus"
            placeholder=" "
            v-model="companyId" />
        </v-col>
        <v-col cols="6" md="1" class="pr-3">
          <v-autocomplete
            v-model="industry"
            :items="Object.entries(settings.industries).map(i => {return i[1] } )"
            :error-messages="errors.industry"
            @change="fieldUpdated('industry')"
            label="Toimiala*"
            persistent-hint
            item-text="fi"
            item-value="id"
          />
        </v-col>
        <v-col cols="6" md="2" class="pr-3">
          <v-text-field
            label="Toimitusosoite*"
            placeholder=" "
            :error-messages="errors.deliveryAddress"
            @blur="fieldUpdated('deliveryAddress')"
            @keyup="fieldUpdated('deliveryAddress')"
            v-model="deliveryAddress" />
        </v-col>
        <v-col cols="6" md="1" class="pr-3">
          <v-text-field
            label="Postikoodi*"
            placeholder=" "
            :error-messages="errors.deliveryPostalCode"
            @blur="fieldUpdated('deliveryPostalCode')"
            @keyup="fieldUpdated('deliveryPostalCode')"
            v-model="deliveryPostalCode" />
        </v-col>
        <v-col cols="6" md="1" class="pr-3">
          <v-text-field
            label="Toimipaikka*"
            placeholder=" " 
            :error-messages="errors.deliveryCity"
            @blur="fieldUpdated('deliveryCity')"
            @keyup="fieldUpdated('deliveryCity')"
            v-model="deliveryCity" />
        </v-col>
        <v-col cols="6" md="1" class="pr-3">
          <v-text-field
            label="Maa*"
            placeholder=" " 
            :error-messages="errors.deliveryCountry"
            @blur="fieldUpdated('deliveryCountry')"
            @keyup="fieldUpdated('deliveryCountry')"
            v-model="deliveryCountry" />
        </v-col>
      </v-row>
      <v-row no-gutters style="width:100%">
        <v-col cols="6" md="2" class="pr-3">
          <v-autocomplete
            v-model="paymentTermNetvisor"
            :items="settings.paymentTerms"
            @change="fieldUpdated('paymentTerm')"
            label="Maksuehto"
            item-text="text"
            item-value="id"
          />
          <!-- <v-text-field
            label="Maksuehto"
            @blur="fieldUpdated('paymentTerm')"
            @keyup="fieldUpdated('paymentTerm')"
            
            v-model="paymentTerm" /> -->
        </v-col>
        <!-- placeholder="14 päivää netto" -->
        <v-col cols="6" md="2" class="pr-3">
          <v-text-field
            label="Viite"
            placeholder=" "
            v-model="billingReferenceDetails" />
        </v-col>
        <v-col cols="12" md="1" class="pr-3">
          <v-autocomplete
            v-model="billingFormat"
            :items="getBillingFormats"
            :error-messages="errors.billingFormat"
            @change="fieldUpdated('billingFormat')"
            placeholder="Laskutusformaatti"
            persistent-hint
            item-text="fi"
            item-value="id"
          />
        </v-col>
        
        <!-- <v-col class="text-left pr-3" cols="12" md="2" v-if="billingFormat === 'email'">
          <v-checkbox 
            label="Onko laskuille eri sähköposti kuin tilaajan sähköposti?"
            v-model="differentBillingEmail" 
            class="avecor-table-checkbox"
            />
        </v-col> -->
        <v-col cols="2" class="pr-3" v-if="billingFormat === 'email'">
          <v-text-field
            label="Laskuille sähköpostiosoite*"
            :error-messages="errors.billingEmail"
            placeholder=" "
            v-model="billingEmail"
            @blur="fieldUpdated('billingEmail')"
            @keyup="fieldUpdated('billingEmail')"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2" v-if="billingFormat === 'eInvoice'" class="pr-3">
          <v-text-field
            label="Verkkolaskutusosoite"
            placeholder=" "
            :error-messages="errors.eBillingAddress"
            @blur="fieldUpdated('eBillingAddress')"
            @keyup="fieldUpdated('eBillingAddress')"
            v-model="eBillingAddress"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2" v-if="billingFormat === 'eInvoice'" class="pr-3">
          <!-- <v-text-field
            label="Operaattori"
            placeholder=" "
            :error-messages="errors.eBillingOperator"
            @blur="fieldUpdated('eBillingOperator')"
            @keyup="fieldUpdated('eBillingOperator')"
            v-model="eBillingOperator"
          ></v-text-field> -->
          <v-autocomplete
            v-model="eBillingOperator"
            :items="settings.eBillingOperators"
            :error-messages="errors.eBillingOperator"
            @change="fieldUpdated('eBillingOperator')"
            label="Verkkolaskun operaattori"
            persistent-hint
            item-text="name"
            item-value="id"
          />
        </v-col>
      </v-row>
      <v-row no-gutters style="width:100%">
        <v-col class="text-left text-left" cols="12" md="1">
          <!-- <v-checkbox 
            label="Eri laskutusosoite?"
            v-model="differentBillingAddress" 
            class="avecor-table-checkbox" /> -->
          <div style="font-size:12px;color:#666;padding-top:20px;padding-left:0px;">
            <input style="vertical-align: middle;" type="checkbox" :checked="differentBillingAddress" @change="differentBillingAddress = !differentBillingAddress"/> 
            <span style="vertical-align: middle;padding-left:5px;">Eri laskutusosoite?</span>
          </div>
        </v-col>
        <v-col cols="6" md="2" v-if="differentBillingAddress" class="pr-3">
          <v-text-field
            label="Laskutusosoite"
            placeholder=" "
            v-model="billingAddress"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2" v-if="differentBillingAddress" class="pr-3">
          <v-text-field
            label="Postikoodi"
            placeholder=" " 
            v-model="billingPostalCode"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2" v-if="differentBillingAddress" class="pr-3">
          <v-text-field
            label="Toimipaikka"
            placeholder=" " 
            v-model="billingCity"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" v-if="differentBillingAddress" class="pr-3">
          <v-text-field
            label="Maa"
            placeholder=" " 
            v-model="billingCountry"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters style="width:100%">
        <v-col cols="6" md="2" class="pr-3">
          <v-autocomplete
            :disabled="selectedExistingOrderId ? true : false"
            v-model="selectedContactId"
            :items="getContacts"
            autocomplete="off"
            label="Valitse kontakti"
            placeholder=" "
            item-text="text"
            item-value="value"
            @change="contactFieldChanged"
          >
            <template v-slot:selection="data">
              <v-chip
                :input-value="data.selected"
                small
                close
                class="chip--select-multi"
                @click:close="removeContactSelection()"
              >
                {{ data.item.text.substr(0,20) }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="6" md="1" class="pr-3">
          <v-text-field
            label="Etunimi*"
            placeholder=" "
            :error-messages="errors.firstName"
            v-model="firstName"
            @blur="fieldUpdated('firstName')"
            @keyup="fieldUpdated('firstName')"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="1" class="pr-3">
          <v-text-field
            label="Sukunimi*"
            placeholder=" "
            :error-messages="errors.lastName"
            @blur="fieldUpdated('lastName')"
            @keyup="fieldUpdated('lastName')"
            v-model="lastName"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="1" class="pr-3">
          <v-text-field
            label="Tilaajan puhelinnumero*"
            placeholder=" "
            :error-messages="errors.clientPhone"
            @blur="fieldUpdated('clientPhone')"
            @keyup="fieldUpdated('clientPhone')"
            v-model="clientPhone"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2" class="pr-3">
          <v-text-field
            label="Tilaajan sähköpostiosoite*"
            placeholder=" "
            :error-messages="errors.clientEmail"
            @blur="fieldUpdated('clientEmail')"
            @keyup="fieldUpdated('clientEmail')"
            v-model="clientEmail"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2" class="pr-3">
          <v-text-field
            label="Vedoksille sähköpostiosoite"
            hint="Täytä vain jos poikkeaa tilaajan sähköpostista."
            persistent-hint
            class="small-hint"
            :error-messages="errors.clientPrintDetailsEmail"
            @blur="fieldUpdated('clientPrintDetailsEmail')"
            @keyup="fieldUpdated('clientPrintDetailsEmail')"
            v-model="clientPrintDetailsEmail" />
        </v-col>
        <v-col cols="6" md="1" class="pr-3">
          <v-autocomplete
            v-model="language"
            :items="[{name:'Suomi',id:'fi'},{name:'Ruotsi',id:'sv'}]"
            @change="fieldUpdated('language')"
            label="Kieli"
            persistent-hint
            item-text="name"
            item-value="id"
          />
        </v-col>
        <v-col cols="6" md="2" style="font-size:12px;color:#666;padding-top:10px;padding-left:10px;">
          <div>
            <input style="vertical-align: middle;" type="checkbox" :checked="sendDraftsToSalesperson" @change="sendDraftsToSalesperson = !sendDraftsToSalesperson"/> 
            <span style="vertical-align: middle;padding-left:5px;">Lähetä vedos vain myyjälle (jos tilauksella merkkauksia)</span>
          </div>
          <div>
            <input style="vertical-align: middle;" type="checkbox" :checked="knownOperator" @change="knownOperator = !knownOperator"/> 
            <span style="vertical-align: middle;padding-left:5px;">Onko tilaaja tunnettu toimija?</span>
          </div>
        </v-col>
        <v-col cols="6" md="2">
        </v-col>
      </v-row>
      <v-row no-gutters style="width:100%">
        <v-col cols="12" md="5" class="pr-3">
          <v-textarea
            label="Tilauksessa muuta huomioitavaa"
            class="new-order-textarea"
            :auto-grow="autogrow"
            rows=1
            placeholder=" "
            v-model="orderComments"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="2" class="pr-3" style="font-size:12px;color:#666;padding-top:15px;padding-left:10px;">
          <input style="vertical-align: middle;" type="checkbox" :checked="splitInvoice" @change="splitInvoice = !splitInvoice"/> 
          <span style="vertical-align: middle;padding-left:5px;">Useampi erä laskulle? Kirjoita toivottu jako muuta huomioitavaa kenttään.</span>
        </v-col>
        <v-col cols="6" md="2" class="pr-3">
          <v-autocomplete
            v-model="selectedDeliveryWeek"
            :items="filteredDeliveryWeeks"
            autocomplete="off"
            label="Toimitusviikko"
            hide-details
          />
        </v-col>
        <v-col cols="6" md="1" class="pr-3">
        </v-col>
        <v-col cols="6" md="2" style="font-size:12px;color:#666;padding-top:15px;padding-left:10px;">
          <div>
            <input style="vertical-align: middle;" type="checkbox" :checked="doNotSendConfirmation" @change="doNotSendConfirmation = !doNotSendConfirmation"/> 
            <span style="vertical-align: middle;padding-left:5px;">Älä lähetä asiakkaalle vahvistusta?</span>
          </div>
          <div>
            <input style="vertical-align: middle;" type="checkbox" :checked="doNotSendMaterialRequestEmail" @change="doNotSendMaterialRequestEmail = !doNotSendMaterialRequestEmail"/> 
            <span style="vertical-align: middle;padding-left:5px;">Älä lähetä asiakkaalle materiaalitiedustelua? (jos tilauksella on merkkauksia)</span>
          </div>
          <div>
            <input style="vertical-align: middle;" type="checkbox" :checked="sendOrderCommentsInConfirmation" @change="sendOrderCommentsInConfirmation = !sendOrderCommentsInConfirmation"/> 
            <span style="vertical-align: middle;padding-left:5px;">Lähetä asiakkaalle muuta huomioitavaa tiedot?</span>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters style="width:100%" v-if="typeOfOrder !== 'sample'">
        <v-col cols="12" md="2" class="pr-3">
          <v-autocomplete
            v-model="referenceOption"
            :items="referenceOptions"
            autocomplete="off"
            label="Referenssi"
            placeholder=" "
            item-text="text"
            item-value="id"
            class=""
          >
            <template v-slot:selection="data">
              <v-chip
                :input-value="data.selected"
                small
                close
                class="chip--select-multi"
                @click:close="referenceOption = '';referenceText='';"
              >
                {{ data.item.text.substr(0,20) }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
         <v-col cols="12" md="5" class="pr-3">
          <v-textarea
            :disabled="referenceOption !== 'referenceReceived'"
            label="Referenssin yhteystiedot"
            class="new-order-textarea"
            :auto-grow="autogrow"
            rows=1
            placeholder=" "
            v-model="referenceText"
          ></v-textarea>
        </v-col>
      </v-row>
      <!-- <v-row no-gutters style="width:100%">
        <v-col cols="12" md="12" class="text-left">
          <v-checkbox 
            label="Onko tämä mallitilaus?"
            v-model="isSamplesOrder" 
             />
        </v-col>
      </v-row> -->
      <v-row no-gutters>
        <v-col cols="12" v-if="selectedExistingOrderId !== ''">
          <div style="font-weight:bold">Tilauksen tuotteet</div>
          <div v-for="(product, index) in getExistingOrderProducts">
            {{product }}
          </div>
        </v-col>
      </v-row>
    </v-row>
    <v-row no-gutters>
        <div class="ml-4" style="color:red">{{errors.samplePackage}}</div>
    </v-row>
    
    <NewOrderNormalGrid v-if="typeOfOrder === 'normal' && loaded" ref="newOrderGrid"></NewOrderNormalGrid>
    <NewOrderSampleGrid v-if="typeOfOrder === 'sample' && loaded" ></NewOrderSampleGrid>
    
  </v-container>  
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import firebase from 'firebase'
import NewOrderNormalGrid from './../../components/blocks/NewOrderNormalGrid'
import NewOrderSampleGrid from './../../components/blocks/NewOrderSampleGrid'
var db = null
import shared from './../../shared'

export default {
    components: {
      NewOrderNormalGrid,
      NewOrderSampleGrid,
    },
    data () {
      return {
        clientPrintDetailsEmailFromCompanyTemp:'',
        showInstructions:false,
        clipped: true,
        right: true,
        miniVariant: true,
        autogrow:true,
        orderSummary:'',
        orderSummaryIds:'',
        samplePackages:{},
        errors: {
          billingEmail:'',
          companyName:"",
          industry:"",
          deliveryAddress:"",
          deliveryAddress:"",
          deliveryPostalCode:"",
          deliveryPostalCity:"",
          deliveryPostalCountry:"",
          eBillingOperator: '',
          eBillingAddress: '',
          firstName:"",
          lastName:"",
          clientPhone:"",
          clientEmail:"",
          clientPrintDetailsEmail:"",
          samplePackage:""
        }
        /*
        selectedCompanyId:"",
        selectedContactId:"",
        existingCompanySelected:false,
        existingContactSelected:false,
        differentBillingAddress:false,
        
        salesperson:"",
        clientName:"",
        clientPhone:"",
        clientOrderDetailsEmail:"",
        clientPrintDetailsEmail:"",
        companyName:"",
        deliveryAddress:"",
        deliveryPostalCode:"",
        deliveryCity:"",
        deliveryCountry:"",
        seperateBillingAddress:"",
        paymentTerm:" ",
        companyId:"",
        orderDate:"",
        orderReference:"",
        orderDeliveryMethod:"",
        orderComments:""
        */
      }
    },
    mounted() {
      const table = this.$refs.table
      this.productsSearch = this.productsSearchTerm
      db = firebase.firestore();

      var t = this
      db.collection("samplePackages")
        .onSnapshot(function(querySnapshot) {
          t.samplePackages = {}
          querySnapshot.forEach(function(doc) {
              t.samplePackages[doc.id] = {...doc.data()}
          });
      })
      
    },
    computed: {
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      getWeeksWithDates(){
        if(!this.settings.weeksArray) return []
        var week = this.getWeek(new Date())
        
        var year = new Date().getFullYear()
        var filteredWeeks = []
        this.settings.weeksArray.forEach(weekYear => {
          var split = weekYear.split("/")
          var s = this.getWeekString(split[0],split[1])
          if(split[0]&& split[1]) filteredWeeks.push(weekYear + ' (' + s + ')')
          else filteredWeeks.push(weekYear)
          
          /* 
          if(split[1] && Number(split[1]) > year){filteredWeeks.push(weekYear + ' (' + s + ')')}
          if(split[1] && Number(split[1]) === year){
            //console.log(split)
            if(split[0] && Number(split[0]) >= week) 
              filteredWeeks.push(weekYear + ' (' + s + ')')
          } */
        })
        console.log(filteredWeeks)
        return filteredWeeks
      },
      filteredDeliveryWeeks(){
        if(!this.settings.weeksArray) return []
        var week = this.getWeek(new Date())
        
        var year = new Date().getFullYear()
        var filteredWeeks = []
        this.settings.weeksArray.forEach(weekYear => {
          var split = weekYear.split("/")
          //console.log(split,year)
          var s = this.getWeekString(split[0],split[1])
          if(split[1] && Number(split[1]) > year){filteredWeeks.push(weekYear + ' (' + s + ')')}
          if(split[1] && Number(split[1]) === year){
            //console.log(split)
            if(split[0] && Number(split[0]) >= week) 
              filteredWeeks.push(weekYear + ' (' + s + ')')
          }
        })
        return filteredWeeks
      },
      getBillingFormats(){
        var billingFormats = this.settings.billingFormats
        return Object.keys(this.settings.billingFormats).reduce(function(result, key) {
          result.push({...billingFormats[key]});
          return result;
        }, []);
      },
      getCompanies(){
        var companies = []
        var twoYearsAgo = new Date()
        var uid = this.user.uid

        var companySharing = this.settings.companySharing

        Object.keys(this.companies).forEach( key => {
          var c = this.companies[key]
          
          var noOrdersInTwoYears = false
          if(!c.latestOrderDate) noOrdersInTwoYears = true
          else if(new Date(c.latestOrderDate) < twoYearsAgo) noOrdersInTwoYears = true

          if (c.id === '4QZ8LZgg2Ks5Cl0J1OyB') companies.push({text: c.companyName, value: c.id})
          else if (this.staff[uid] && (this.staff[uid].role === "office" || this.staff[uid].isAdmin)) companies.push({text: c.companyName, value: c.id})
          else{
            // KATRIN FIRMAT
            if(companySharing[c.salesperson] && companySharing[c.salesperson].includes(uid) && noOrdersInTwoYears) {}
            else if (c.salesperson !== uid) return

            companies.push({text: c.companyName, value: c.id})

            
            //else if (this.user.uid === "GTNKFjWUHNhcAJVbORirRPNvCnv1") companies.push({text: c.companyName, value: c.id})
          }
          
          //else if (this.user.uid === "p2VRFkTz4JUzqkGoTPUt4CWQAxa2") companies.push({text: c.companyName, value: c.id})
          
        })
        return companies
      },
      getOrders(){
        var orders = []
        var ordersWithOnlyNewStatuses = {}
        Object.keys(this.orderedProducts).forEach(key => {
          var op = this.orderedProducts[key]
          if(op.orderStatus === 'new' && ordersWithOnlyNewStatuses[op.orderId] === undefined) ordersWithOnlyNewStatuses[op.orderId] = true
          else if(op.orderStatus === 'new' && ordersWithOnlyNewStatuses[op.orderId] === false) ordersWithOnlyNewStatuses[op.orderId] = false
          else if(op.orderStatus === 'new' && ordersWithOnlyNewStatuses[op.orderId] === true) ordersWithOnlyNewStatuses[op.orderId] = true
        })

        Object.keys(ordersWithOnlyNewStatuses).forEach(key => {
          if(ordersWithOnlyNewStatuses[key]){
            var o = this.orders[key]
            if(o === undefined) return
            
            if(this.companies[o.companyId] === undefined) return
            if(this.allAccess) orders.push({text: this.companies[o.companyId].companyName + " - " + this.customFormatter(o.created_at), value: o.id})
            else if (this.user.uid === "GTNKFjWUHNhcAJVbORirRPNvCnv1") orders.push({text:this.companies[o.companyId].companyName + " - " + this.customFormatter(o.created_at), value: o.id})
            //else if (this.user.uid === "p2VRFkTz4JUzqkGoTPUt4CWQAxa2") orders.push({text:this.companies[o.companyId].companyName + " - " + this.customFormatter(o.created_at), value: o.id})
            
            else if (o.salesperson === this.user.uid) orders.push({text:this.companies[o.companyId].companyName + " - " + this.customFormatter(o.created_at), value: o.id})  
          }
        })



        /* Object.keys(this.orders).forEach(key => {
          var o = this.orders[key]
          if(this.companies[o.companyId] === undefined) return
          if(this.allAccess) orders.push({text: this.companies[o.companyId].companyName + " - " + this.customFormatter(o.created_at), value: o.id})
          else if (this.user.uid === "GTNKFjWUHNhcAJVbORirRPNvCnv1") orders.push({text:this.companies[o.companyId].companyName + " - " + this.customFormatter(o.created_at), value: o.id})
          //else if (this.user.uid === "p2VRFkTz4JUzqkGoTPUt4CWQAxa2") orders.push({text:this.companies[o.companyId].companyName + " - " + this.customFormatter(o.created_at), value: o.id})
          
          else if (o.salesperson === this.user.uid) orders.push({text:this.companies[o.companyId].companyName + " - " + this.customFormatter(o.created_at), value: o.id})
        }) */
        return orders
      },
      getExistingOrderProducts(){
        var existingOrderProducts = []
        var t = this
        Object.keys(this.orderedProducts).forEach(function(key, index) {
          var op = t.orderedProducts[key]
          if(op.orderId === t.selectedExistingOrderId && t.products[op.productId].name !== undefined) existingOrderProducts.push(t.products[op.productId].name.fi + " " + op.quantity + " x " + op.unitPrice + "€")
          //if(op.orderId === t.selectedExistingOrderId && t.products[op.productId].name !== undefined) t.orderSummary += t.products[op.productId].name.fi + " x " +op.quantity + ";"
          //if(op.orderId === t.selectedExistingOrderId) t.orderSummaryIds += op.productVariationId + " " + t.productVariations[op.productVariationId].sku + ";"
        })
        return existingOrderProducts
      },
      getContacts(){
        var contacts = this.contacts
        var selectedCompanyId = this.selectedCompanyId
        var filteredContacts = []
        Object.keys(this.contacts).reduce(function(acc, key) {
          var c = contacts[key]
          if(c.companyId === selectedCompanyId) filteredContacts.push({text: c.firstName+" "+c.lastName, value: c.id})
          return acc + 1
        },0)
        return filteredContacts
      },
      
      ...mapFields({
        printShops:"printShop.printShops",
        companies:'company.companies',
        orders:'order.orders',
        products:'product.products',
        orderedProducts:'orderedProduct.orderedProducts',
        staff:'staff.staff',
        contacts:'contact.contacts',
        productVariations:'productVariation.productVariations',
        isAuthenticated:'settings.isAuthenticated',
        isSales:'settings.isSales',
        loaded:'settings.loaded',
        isOffice:'settings.isOffice',
        officeView:'selectedView.officeView',
        salesView:'selectedView.salesView',
        clientView:'selectedView.clientView',
        clientNameTags:'clientNameTags',
        settings:'settings',
        signInLoader:'settings.signInLoader',
        referenceOptions:'settings.referenceOptions',
        user:'user',
        selectedSamplePackage:"newOrderDetails.selectedSamplePackage",
        selectedSamplePackageProductVariations:"newOrderDetails.selectedSamplePackageProductVariations",
        selectedExistingOrderId:'newOrderDetails.selectedExistingOrderId',
        selectedCompanyId:'newOrderDetails.selectedCompanyId',
        selectedContactId:'newOrderDetails.selectedContactId',
        selectedDeliveryWeek:'newOrderDetails.selectedDeliveryWeek',
        selectedProductId:'newOrderDetails.selectedProductId',
        typeOfOrder:'newOrderDetails.typeOfOrder',
        existingCompanySelected:'newOrderDetails.existingCompanySelected',
        existingProductSelected:'newOrderDetails.existingProductSelected',
        existingContactSelected:'newOrderDetails.existingContactSelected',
        differentBillingAddress:'newOrderDetails.differentBillingAddress',
        differentBillingEmail:'newOrderDetails.differentBillingEmail',
        billingEInvoiceNumber:'newOrderDetails.billingEInvoiceNumber',
        eBillingAddress:'newOrderDetails.eBillingAddress',
        eBillingOperator:'newOrderDetails.eBillingOperator',
        billingEmail:"newOrderDetails.billingEmail",
        billingFormat:"newOrderDetails.billingFormat",
        salesperson:"newOrderDetails.salesperson",
        clientName:"newOrderDetails.clientName",
        firstName:"newOrderDetails.firstName",
        lastName:"newOrderDetails.lastName",
        language:"newOrderDetails.language",
        clientPhone:"newOrderDetails.clientPhone",
        clientEmail:"newOrderDetails.clientEmail",
        knownOperator:"newOrderDetails.knownOperator",
        sendDraftsToSalesperson:"newOrderDetails.sendDraftsToSalesperson",
        sendConfirmation:"newOrderDetails.sendConfirmation",
        doNotSendConfirmation:"newOrderDetails.doNotSendConfirmation",
        splitInvoice:"newOrderDetails.splitInvoice",
        doNotSendMaterialRequestEmail:"newOrderDetails.doNotSendMaterialRequestEmail",
        additionalCustomerInformation:"newOrderDetails.additionalCustomerInformation",
        clientOrderDetailsEmail:"newOrderDetails.clientOrderDetailsEmail",
        clientPrintDetailsEmail:"newOrderDetails.clientPrintDetailsEmail",
        companyName:"newOrderDetails.companyName",
        companyId:"newOrderDetails.companyId",
        industry:"newOrderDetails.industry",
        deliveryAddress:"newOrderDetails.deliveryAddress",
        deliveryPostalCode:"newOrderDetails.deliveryPostalCode",
        deliveryCity:"newOrderDetails.deliveryCity",
        deliveryCountry:"newOrderDetails.deliveryCountry",
        
        billingAddress:"newOrderDetails.billingAddress",
        billingPostalCode:"newOrderDetails.billingPostalCode",
        billingCity:"newOrderDetails.billingCity",
        billingCountry:"newOrderDetails.billingCountry",
        billingReferenceDetails:"newOrderDetails.billingReferenceDetails",
        seperateBillingAddress:"newOrderDetails.seperateBillingAddress",
        paymentTerm:"newOrderDetails.paymentTerm",
        paymentTermNetvisor:"newOrderDetails.paymentTermNetvisor",
        orderDate:"newOrderDetails.orderDate",
        orderReference:"newOrderDetails.orderReference",
        orderDeliveryMethod:"newOrderDetails.orderDeliveryMethod",
        orderComments:"newOrderDetails.orderComments",
        sendOrderCommentsInConfirmation:"newOrderDetails.sendOrderCommentsInConfirmation",
        deliveryCharges:"newOrderDetails.deliveryCharges",
        deliveryBySalesperson:"newOrderDetails.deliveryBySalesperson",
        isAmendmentOrder:"newOrderDetails.isAmendmentOrder",
        referenceOption:"newOrderDetails.referenceOption",
        referenceText:"newOrderDetails.referenceText",
      }),
      ...mapMultiRowFields({
        newOrderProducts: "newOrderDetails.products2",
        productsErrors: "newOrderDetails.productsErrors"
      })
    },
    created () {
      this.formNewBatchDataset = shared.formNewBatchDataset
      this.createVariationName = shared.createVariationName
      this.createVariationAvecorSku = shared.createVariationAvecorSku
      this.getWeekString = shared.getWeekString
      this.getWeek = shared.getWeek
      this.printFormatsFromPricingForProduct = shared.printFormatsFromPricingForProduct
    },
    methods: {
      timer(ms) { return new Promise(res => setTimeout(res, ms)); },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      resendConfirmantionEmail(){
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Tilausvahvistusta lähetetään.", snackButtonText: "OK", errorType:"", snackColor:'deep-blue',right:true,top:true})
        var opIds = []
        Object.keys(this.orderedProducts).forEach(key => {
          var op = this.orderedProducts[key]
          if(op.orderId === this.selectedExistingOrderId) opIds.push(key)
        })
        var companyId = this.orders[this.selectedExistingOrderId].companyId
        var contactId = this.orders[this.selectedExistingOrderId].contactId

        this.$store.dispatch('sendMessageServerSide', {
          toEmail:this.user.email,
          fromEmail:this.user.email,
          customer:false,
          opIds,
          companyId,
          contactId,
          orderId:this.selectedExistingOrderId,
          typeOfSend:'order_confirmation'
        })
        /* if(this.sendConfirmation && this.clientEmail){
          this.$store.dispatch('sendMessageServerSide', {
            toEmail:this.clientEmail,
            fromEmail:this.user.email,
            customer:true,
            opIds,
            companyId,
            contactId,
            orderId:this.selectedExistingOrderId,
            typeOfSend:'order_confirmation'
          })
        } */
        if(!this.doNotSendConfirmation && this.clientEmail){
          this.$store.dispatch('sendMessageServerSide', {
            toEmail:this.clientEmail,
            fromEmail:this.user.email,
            customer:true,
            opIds,
            companyId,
            contactId,
            orderId:this.selectedExistingOrderId,
            typeOfSend:'order_confirmation'
          })
        }
        
      },
      resetOrder(){
        var errors = this.errors
        Object.keys(this.errors).forEach(errorKey => errors[errorKey] = "")
        this.$store.dispatch('resetProducts', "")
        this.selectedCompanyId = ''
        this.selectedDeliveryWeek = ''
        this.selectedContactId = ''
        this.selectedExistingOrderId = ''
        this.existingCompanySelected = false
        this.existingContactSelected = false
        this.differentBillingEmail = false
        this.eBillingAddress = ""
        this.eBillingOperator = ""
        this.billingEmail = ""
        this.billingFormat= "eInvoice"
        this.clientName = ""
        this.firstName = ""
        this.lastName = ""
        this.clientPhone = ""
        this.language = "fi"
        this.clientEmail = ""
        this.knownOperator = false
        this.sendDraftsToSalesperson = false,
        this.sendConfirmation = false
        this.doNotSendConfirmation = false
        this.splitInvoice = false
        this.doNotSendMaterialRequestEmail = false
        this.additionalCustomerInformation = ""
        this.clientOrderDetailsEmail = ""
        this.clientPrintDetailsEmail = ""
        this.companyName = ""
        this.companyId = ""
        this.industry = ""
        this.deliveryAddress = ""
        this.deliveryPostalCode = ""
        this.deliveryCity = ""
        this.deliveryCountry = "Finland"
        this.billingReferenceDetails = ""
        this.billingAddress = ""
        this.billingPostalCode = ""
        this.billingCity = ""
        this.billingCountry = "Finland"
        this.seperateBillingAddress = ""
        this.paymentTerm = "14 päivää netto"
        this.paymentTermNetvisor = 14
        this.orderDate = "",
        this.orderReference = ""
        this.orderDeliveryMethod = ""
        this.orderComments = ""
        this.referenceOption = ""
        this.referenceText = ""
        this.sendOrderCommentsInConfirmation = false,
        this.orderSummary = ''
        this.orderSummaryIds = ''
        this.deliveryCharges = "24.90"
        this.deliveryBySalesperson = false
        this.isAmendmentOrder = false
        console.log("RESEETING")
        this.$refs.newOrderGrid.addRow()
      },
      fieldUpdated(field){
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        field === "companyName" && this.companyName.trim() === "" ? this.errors.companyName = "Täytä" : null
        field === "companyName" && this.companyName.trim() !== "" ? this.errors.companyName = "" : null
        field === "industry" && this.industry.trim() !== "" ? this.errors.industry = "" : null
        field === "deliveryAddress" && this.deliveryAddress.trim() === "" ? this.errors.deliveryAddress = "Täytä" : null
        field === "deliveryAddress" && this.deliveryAddress.trim() !== "" ? this.errors.deliveryAddress = "" : null
        field === "deliveryPostalCode" && this.deliveryPostalCode.trim() === "" ? this.errors.deliveryPostalCode = "Täytä" : null
        field === "deliveryPostalCode" && this.deliveryPostalCode.trim() !== "" ? this.errors.deliveryPostalCode = "" : null
        field === "deliveryCity" && this.deliveryCity.trim() === "" ? this.errors.deliveryCity = "Täytä" : null
        field === "deliveryCity" && this.deliveryCity.trim() !== "" ? this.errors.deliveryCity = "" : null
        field === "deliveryCountry" && this.deliveryCountry.trim() === "" ? this.errors.deliveryCountry = "Täytä" : null
        field === "deliveryCountry" && this.deliveryCountry.trim() !== "" ? this.errors.deliveryCountry = "" : null
        
        //field === "billingFormat" && this.billingFormat.trim() === "" ? this.errors.billingFormat = "Täytä" : null
        //field === "billingFormat" && this.billingFormat.trim() !== "" ? this.errors.billingFormat = "" : null
        if(field === "billingFormat") { 
          this.billingAddress = ""
          this.billingPostalCode = ""
          this.billingCity = ""
          this.billingCountry = "Finland"
          this.eBillingAddress = ""; 
          this.eBillingOperator= "";
          this.differentBillingEmail = false; 
          this.differentBillingAddress = false;
          this.errors.billingFormat = ""
          this.errors.eBillingAddress = ""
          this.errors.eBillingOperator = ""
          this.errors.billingEmail = ""
        }
        field === "firstName" && this.firstName.trim() === "" ? this.errors.firstName = "Täytä" : null
        field === "firstName" && this.firstName.trim() !== "" ? this.errors.firstName = "" : null
        field === "lastName" && this.lastName.trim() === "" ? this.errors.lastName = "Täytä" : null
        field === "lastName" && this.lastName.trim() !== "" ? this.errors.lastName = "" : null
        field === "clientPhone" && this.clientPhone.trim() === "" ? this.errors.clientPhone = "Täytä" : null
        field === "clientPhone" && this.clientPhone.trim() !== "" ? this.errors.clientPhone = "" : null
        field === "billingEmail" && this.billingEmail.trim() === "" ? this.errors.billingEmail = "Täytä" : null
        field === "billingEmail" && this.billingEmail.trim() !== "" ? this.errors.billingEmail = "" : null
        
        if(field === "clientEmail" && this.clientEmail.trim() === "") {
          this.errors.clientEmail = "Täytä"
        } 
        else if (field === "clientEmail" && !pattern.test(this.clientEmail)) this.errors.clientEmail = "Ei kelpaa"
        else this.errors.clientEmail = ""
        
      },
      removeExistingOrderSelection () {
        this.selectedExistingOrderId = ''
        this.selectedCompanyId = ''
        this.selectedContactId = ''
        this.existingCompanySelected = false
        this.existingContactSelected = false
        this.typeOfOrder = 'normal'
        this.orderComments = ''
        this.referenceOption = ''
        this.referenceText = ''
        this.orderSummary = ''
        this.orderSummaryIds = ''
        this.companyFieldChanged()
        this.contactFieldChanged()
        var errors = this.errors
        Object.keys(this.errors).forEach(errorKey => errors[errorKey] = "")
        
      },
      removeCompanySelection () {
        this.selectedCompanyId = ''
        this.selectedContactId = ''
        this.existingCompanySelected = false
        this.existingContactSelected = false
        this.companyFieldChanged()
        this.contactFieldChanged()
        var errors = this.errors
        Object.keys(this.errors).forEach(errorKey => errors[errorKey] = "")
        
      },
      removeContactSelection () {
        this.selectedContactId = ''
        this.existingContactSelected = false
        this.contactFieldChanged()
        var errors = this.errors
        Object.keys(this.errors).forEach(errorKey => errors[errorKey] = "")
      },
      
      existingOrderFieldChanged(){
        //console.log(this.selectedExistingOrderId)
        this.selectedCompanyId = this.orders[this.selectedExistingOrderId].companyId
        this.companyFieldChanged(true)
        this.selectedContactId = this.orders[this.selectedExistingOrderId].contactId
        this.contactFieldChanged()
        console.log(this.selectedContactId)
        this.selectedDeliveryWeek = this.orders[this.selectedExistingOrderId].deliveryWeek ? this.orders[this.selectedExistingOrderId].deliveryWeek : ''
        this.orderComments = this.orders[this.selectedExistingOrderId].orderComments
        this.referenceOption = this.orders[this.selectedExistingOrderId].referenceOption
        this.referenceText = this.orders[this.selectedExistingOrderId].referenceText
        this.splitInvoice = this.orders[this.selectedExistingOrderId].splitInvoice ? true : false
        var isSampleOrder = this.orders[this.selectedExistingOrderId].sample !== undefined ? this.orders[this.selectedExistingOrderId].sample : false
        this.typeOfOrder = isSampleOrder ? 'sample' : 'normal'
        this.deliveryCharges = this.orders[this.selectedExistingOrderId].deliveryCharge
        
        
      },
      companyFieldChanged(isViaOrderChange) {
        this.clientPrintDetailsEmailFromCompanyTemp = ''
        if(!isViaOrderChange) this.removeContactSelection()
        this.selectedCompanyId === "" ? this.existingCompanySelected = false : this.existingCompanySelected = true
        this.selectedCompanyId && this.companies[this.selectedCompanyId].companyName !== undefined ? this.companyName = this.companies[this.selectedCompanyId].companyName : this.companyName = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].companyId !== undefined ? this.companyId = this.companies[this.selectedCompanyId].companyId : this.companyId = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].industry !== undefined ? this.industry = this.companies[this.selectedCompanyId].industry : this.industry = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].paymentTerm !== undefined ? this.paymentTerm = this.companies[this.selectedCompanyId].paymentTerm : this.paymentTerm = "14 päivää netto"
        this.selectedCompanyId && this.companies[this.selectedCompanyId].paymentTermNetvisor !== undefined ? this.paymentTermNetvisor = this.companies[this.selectedCompanyId].paymentTermNetvisor : this.paymentTermNetvisor = 14
        this.selectedCompanyId && this.companies[this.selectedCompanyId].additionalCustomerInformation !== undefined ? this.additionalCustomerInformation = this.companies[this.selectedCompanyId].additionalCustomerInformation : this.additionalCustomerInformation = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].knownOperator !== undefined ? this.knownOperator = this.companies[this.selectedCompanyId].knownOperator : this.knownOperator = false
        // LOAD PREVIOUSLY STORED COMPANY LEVEL CLIENT PRINT DETAILS TO TEMP VARIABLE

        this.selectedCompanyId && this.companies[this.selectedCompanyId].clientPrintDetailsEmail !== undefined ? this.clientPrintDetailsEmailFromCompanyTemp = this.companies[this.selectedCompanyId].clientPrintDetailsEmail : this.clientPrintDetailsEmail = ""

        this.selectedCompanyId && this.companies[this.selectedCompanyId].billingFormat !== undefined ? this.billingFormat = this.companies[this.selectedCompanyId].billingFormat : this.billingFormat = ""
        
        this.selectedCompanyId && this.companies[this.selectedCompanyId].differentBillingEmail !== undefined ? this.differentBillingEmail = this.companies[this.selectedCompanyId].differentBillingEmail : this.differentBillingEmail = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].billingEmail !== undefined ? this.billingEmail = this.companies[this.selectedCompanyId].billingEmail : this.billingEmail = ""

        this.selectedCompanyId && this.companies[this.selectedCompanyId].eBillingAddress !== undefined ? this.eBillingAddress = this.companies[this.selectedCompanyId].eBillingAddress : this.eBillingAddress = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].eBillingOperator !== undefined ? this.eBillingOperator = this.companies[this.selectedCompanyId].eBillingOperator : this.eBillingOperator = ""
        
        this.selectedCompanyId && this.companies[this.selectedCompanyId].differentBillingAddress !== undefined ? this.differentBillingAddress = this.companies[this.selectedCompanyId].differentBillingAddress : this.differentBillingAddress = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].billingAddress !== undefined ? this.billingAddress = this.companies[this.selectedCompanyId].billingAddress : this.billingAddress = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].billingPostalCode !== undefined ? this.billingPostalCode = this.companies[this.selectedCompanyId].billingPostalCode : this.billingPostalCode = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].billingCity !== undefined  ? this.billingCity = this.companies[this.selectedCompanyId].billingCity : this.billingCity = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].billingCountry !== undefined  ? this.billingCountry = this.companies[this.selectedCompanyId].billingCountry : this.billingCountry = ""

        this.selectedCompanyId && this.companies[this.selectedCompanyId].deliveryAddress !== undefined ? this.deliveryAddress = this.companies[this.selectedCompanyId].deliveryAddress : this.deliveryAddress = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].deliveryPostalCode !== undefined ? this.deliveryPostalCode = this.companies[this.selectedCompanyId].deliveryPostalCode : this.deliveryPostalCode = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].deliveryCity !== undefined ? this.deliveryCity = this.companies[this.selectedCompanyId].deliveryCity : this.deliveryCity = ""
        this.selectedCompanyId && this.companies[this.selectedCompanyId].deliveryCountry !== undefined ? this.deliveryCountry = this.companies[this.selectedCompanyId].deliveryCountry : this.deliveryCountry = ""

        this.fieldUpdated("companyName")
        this.fieldUpdated("industry")
        this.fieldUpdated("deliveryAddress")
        this.fieldUpdated("deliveryPostalCode")
        this.fieldUpdated("deliveryCity")
      },
      contactFieldChanged() {
        this.selectedContactId === "" ? this.existingContactSelected = false : this.existingContactSelected = true
        this.selectedContactId && this.contacts[this.selectedContactId].firstName !== undefined && this.contacts[this.selectedContactId].firstName ? this.firstName = this.contacts[this.selectedContactId].firstName : this.firstName = ""
        this.selectedContactId && this.contacts[this.selectedContactId].lastName !== undefined && this.contacts[this.selectedContactId].lastName ? this.lastName = this.contacts[this.selectedContactId].lastName : this.lastName = ""
        this.selectedContactId && this.contacts[this.selectedContactId].phone !== undefined && this.contacts[this.selectedContactId].phone ? this.clientPhone = this.contacts[this.selectedContactId].phone : this.clientPhone = ""
        this.selectedContactId && this.contacts[this.selectedContactId].language !== undefined && this.contacts[this.selectedContactId].language ? this.language = this.contacts[this.selectedContactId].language : this.language = "fi"
        this.selectedContactId && this.contacts[this.selectedContactId].email !== undefined && this.contacts[this.selectedContactId].email ? this.clientEmail = this.contacts[this.selectedContactId].email : this.clientEmail = ""
        this.selectedContactId && this.contacts[this.selectedContactId].sendDraftsToSalesperson !== undefined ? this.sendDraftsToSalesperson = this.contacts[this.selectedContactId].sendDraftsToSalesperson : this.sendDraftsToSalesperson = false
        this.selectedContactId && this.contacts[this.selectedContactId].sendConfirmation !== undefined && this.contacts[this.selectedContactId].sendConfirmation ? this.sendConfirmation = this.contacts[this.selectedContactId].sendConfirmation : this.sendConfirmation = false
        this.selectedContactId && this.contacts[this.selectedContactId].doNotSendConfirmation !== undefined ? this.doNotSendConfirmation = this.contacts[this.selectedContactId].doNotSendConfirmation : this.doNotSendConfirmation = false
        this.selectedContactId && this.contacts[this.selectedContactId].doNotSendMaterialRequestEmail !== undefined ? this.doNotSendMaterialRequestEmail = this.contacts[this.selectedContactId].doNotSendMaterialRequestEmail : this.doNotSendMaterialRequestEmail = false
        this.selectedContactId && this.contacts[this.selectedContactId].additionalCustomerInformation !== undefined ? this.additionalCustomerInformation = this.contacts[this.selectedContactId].additionalCustomerInformation : this.additionalCustomerInformation = ""

        if(this.selectedContactId && this.contacts[this.selectedContactId].clientPrintDetailsEmail !== undefined){
          this.clientPrintDetailsEmail = this.contacts[this.selectedContactId].clientPrintDetailsEmail
        }
        else if(this.clientPrintDetailsEmailFromCompanyTemp && this.clientEmail.trim() !== this.clientPrintDetailsEmailFromCompanyTemp){
          this.clientPrintDetailsEmail = this.clientPrintDetailsEmailFromCompanyTemp
        }
        else {
          this.clientPrintDetailsEmail = ''
        }
        

        this.fieldUpdated("firstName")
        this.fieldUpdated("lastName")
        this.fieldUpdated("clientPhone")
        this.fieldUpdated("clientEmail")
        
      },
      async validateAndCreateOrder() {
          var errors = []
          var errorsVisible = this.errors
          var productsErrors = this.productsErrors
          //var printFormatsFromPricingForProduct = this.printFormatsFromPricingForProduct
          Object.keys(this.errors).forEach(errorKey => errorsVisible[errorKey] = "")
          this.productsErrors.forEach((product,i) => {
            Object.keys(product).forEach(errorKey => productErrors[i][errorKey] = "")
          })
          if (this.companyName === undefined || this.companyName.trim() == "") { this.errors.companyName = "Täytä"; errors.push("Yrityksen nimi") }
          if (this.industry === undefined || this.industry.trim() == "") { this.errors.industry = "Täytä"; errors.push("Yrityksen toimiala") }
          if (this.deliveryAddress === undefined || this.deliveryAddress.trim() == "") { this.errors.deliveryAddress = "Täytä"; errors.push("Toimitusosoite") }
          if (this.deliveryPostalCode === undefined || this.deliveryPostalCode.trim() == "") { this.errors.deliveryPostalCode = "Täytä"; errors.push("Postikoodi") }
          if (this.deliveryCity === undefined || this.deliveryCity.trim() == "") { this.errors.deliveryCity = "Täytä"; errors.push("Toimipaikka")}
          if (this.deliveryCountry === undefined || this.deliveryCountry.trim() == "") { this.errors.deliveryCountry = "Täytä"; errors.push("Maa") }
          
          //if (this.billingFormat.trim() == "") { this.errors.billingFormat = "Täytä"; errors.push("Laskutusformaatti") }
          //if (this.billingFormat.trim() == "eInvoice" && this.eBillingOperator == "") { this.errors.eBillingOperator = "Täytä"; errors.push("Sähkölaskutuksen operaattori") }
          //if (this.billingFormat.trim() == "eInvoice" && this.eBillingAddress == "") { this.errors.eBillingAddress = "Täytä"; errors.push("Verkkolaskutusosoite") }
          if (this.firstName === undefined || this.firstName.trim() == "") {this.errors.firstName = "Täytä"; errors.push("Tilaajan etunimi") }
          if (this.lastName === undefined || this.lastName.trim() == "") { this.errors.lastName = "Täytä"; errors.push("Tilaajan sukunimi") }
          if (this.clientPhone === undefined || this.clientPhone.trim() == "") { this.errors.clientPhone = "Täytä"; errors.push("Tilaajan puhelin")}
          if (this.clientEmail === undefined || this.clientEmail.trim() == "") { this.errors.clientEmail = "Täytä"; errors.push("Tilaajan sähköposti") }
          if (this.billingFormat === 'email' && this.billingEmail.trim() === "") { this.errors.billingEmail = "Täytä"; errors.push("Laskutuksen sähköposti")}
          var productsErrors = this.productsErrors
          var clientPrintDetailsEmail = this.clientPrintDetailsEmail
          var products = this.products

          if(this.typeOfOrder === 'sample'){
            if(this.selectedSamplePackage === '') {this.errors.samplePackage = "Valitse mallipaketti"; errors.push("Valitse mallipaketti")}
          }
          else {
            this.newOrderProducts.forEach((product,i) => {
              //if (product.productId.trim() === "") {productsErrors[i].productId = "Täytä"; errors.push("product " + i + " error" )}
              
              //if (product.productVariationId.trim() === "") {productsErrors[i].productVariationId = "Täytä"; errors.push("billingEmail")}
              //if ((clientPrintDetailsEmail === undefined || clientPrintDetailsEmail.trim() == "") && product.print) { errorsVisible.clientPrintDetailsEmail = "Täytä"; errors.push("Vedosten sähköposti") }
              if (product.productName === undefined || product.productName.trim() === "") {productsErrors[i].productName = "Valitse tuote vasemmalta."; errors.push(`Tuotenimi ${i+1} tuotteelle`)}
              //if (product.packageType === undefined || product.packageType.trim() === "") {productsErrors[i].packageType = "Valitse tuote vasemmalta."; errors.push("Pakkaustyyppi tuotteelle:" + i )}
              //if (product.customerProductName.trim() === "") {productsErrors[i].customerProductName = "Täytä"; errors.push("Asiakkaalle näkyvä nimi tuoteriville:" + i )}
              if (this.typeOfOrder !== 'sample') {
                if (product.quantity === undefined || product.quantity.trim() === "") {productsErrors[i].quantity = "Täytä"; errors.push(`Määrä puuttuu ${i+1} tuotteelle`)}
                if (product.unitPrice === undefined || product.unitPrice.trim() === "") {productsErrors[i].unitPrice = "Täytä"; errors.push(`Tuotteen á hinta puuttuu ${i+1} tuotteelle`)}
              }

              if (product.print){
                if (product.printQuantity === undefined || product.printQuantity.trim() === "") {productsErrors[i].printQuantity = "Täytä"; errors.push(`Merkkausten määrä puuttuu ${i+1} tuotteelle.`)}
                // HINNASTON
                if(this.products[product.productId].listed && this.products[product.productId].isMarginCalculationActivated){
                  if(!product.printOptions || product.printOptions.length == 0) {
                    productsErrors[i].printOptions = "Valitse merkkaustapa."; errors.push(`Merkkaustapa puuttuu ${i+1} tuotteelle.`)
                  }
                  var pos = product.printOptionsSettings
                  var po =  product.printOptions
                  var items = this.printFormatsFromPricingForProduct(product.productId)
                  
                  po.forEach(o => {
                    if(o.split('__').length > 1 && o.split('__')[0] === 'product'){
                      var pfId = null
                      items.forEach(f => {
                        f.id == o ? pfId = f.pfId : ''
                      })
                      var poId = o.split('__')[1]
                      var numberOfColorsNeeded = true
                      console.log(pfId)
                      if (pfId === 'laser' || pfId === 'digital_print' || pfId === 'uv_laser') numberOfColorsNeeded = false  
                      if(numberOfColorsNeeded){
                        console.log('POS ', pos)
                        if(!pos[o] || !pos[o].colors || pos[o].colors === 0) {
                          productsErrors[i].printOptions = "Värien määrä puuttuu."; errors.push(`Merkkaustavan väri puutttuu ${i+1} tuotteelle.`)
                        }
                      }
                    }
                  })

                  if(product.secondPrint){
                    if(!product.printOptions2 || product.printOptions2.length == 0) {
                      productsErrors[i].printOptions2 = "Valitse merkkaustapa."; errors.push(`Merkkaustapa 2 puuttuu ${i+1} tuotteelle.`)
                    }
                    var pos = product.printOptionsSettings2
                    var po =  product.printOptions2
                    var items = this.printFormatsFromPricingForProduct(product.productId)
                    
                    po.forEach(o => {
                      if(o.split('__').length > 1 && o.split('__')[0] === 'product'){
                        var pfId = null
                        items.forEach(f => {
                          f.id == o ? pfId = f.pfId : ''
                        })
                        var poId = o.split('__')[1]
                        var numberOfColorsNeeded = true
                        console.log(pfId)
                        if (pfId === 'laser' || pfId === 'digital_print' || pfId === 'uv_laser') numberOfColorsNeeded = false  
                        if(numberOfColorsNeeded){
                          console.log('POS ', pos)
                          if(!pos[o] || !pos[o].colors || pos[o].colors === 0) {
                            productsErrors[i].printOptions2 = "Värien määrä puuttuu."; errors.push(`Merkkaustavan väri puutttuu ${i+1} tuotteelle.`)
                          }
                        }
                      }
                    })
                  }
                  
                }
                else {
                  var arePrintFormatsSpecifiedForProduct = products[product.productId] && products[product.productId].printFormats && Array.isArray(products[product.productId].printFormats) && products[product.productId].printFormats.length > 0 ? true : false
                  if(arePrintFormatsSpecifiedForProduct && product.printFormats.length == 0){
                    console.log("HERE1")
                    //if (product.print && product.printFormats.length == 0){
                    productsErrors[i].printFormats = "Valitse merkkaustapa."; errors.push(`Merkkaustapa puuttuu ${i+1} tuotteelle.`)
                  }
                  else if(!arePrintFormatsSpecifiedForProduct && product.printFormatsText === '') {
                    console.log(product)
                    console.log("HERE2")
                    productsErrors[i].printFormatsText = "Lisää merkkaustapa."; errors.push(`Merkkaustapa puuttuu ${i+1} tuotteelle.`)
                  }

                  // IS A PRINT FORMAT THAT DOESN'T REQUIRE NUMBER OF COLORS
                  var numberOfColorsNeeded = true
                  if (product.printFormats.includes('laser') || product.printFormats.includes('digital_print') || product.printFormats.includes('uv_laser')) numberOfColorsNeeded = false
                  

                  if (product.print && !product.numberOfPrintColors && numberOfColorsNeeded){
                    productsErrors[i].numberOfPrintColors = "Valitse värien määrä."; errors.push(`Värien määrä puuttuu ${i+1} tuotteelle.`)
                  }
                }
              }
            })
          }

          
          console.log(errors)
          if(errors.length > 0) {
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackButtonText: "OK", snackText:"Täytä puuttuvat kentät " + errors.join(', '), snackColor:'error',right:true,top:true})
          }
          else this.createOrder()
          
      },
      async createOrder() {
        try{
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Tilausta tallennetaan...", snackButtonText: "OK", errorType:"", snackColor:'deep-blue',right:true,top:true})
          var companyDBId = ""
          var contactDBId = ""
          var latestOrderDate = this.customFormatter(new Date())
          const increment = firebase.firestore.FieldValue.increment(1);
          var companyId = this.companyId ? this.companyId : ''
          companyId = companyId.trim()
          companyId = companyId.replace(/\'/g,'')
          companyId = companyId.replace(/,/g,'')
          companyId = companyId.replace(/\./g,'')

          var companyData = {
            companyName:this.companyName,
            companyId:companyId,
            industry:this.industry ? this.industry : '',
            knownOperator:this.knownOperator ? true : false,
            paymentTerm:this.paymentTerm,
            paymentTermNetvisor:this.paymentTermNetvisor,
            deliveryAddress:this.deliveryAddress,
            deliveryPostalCode:this.deliveryPostalCode,
            deliveryCity:this.deliveryCity,
            deliveryCountry:this.deliveryCountry,
            billingFormat:this.billingFormat,
            billingEmail: this.billingEmail ? this.billingEmail : '',
            eBillingAddress: this.eBillingAddress,
            eBillingOperator: this.eBillingOperator,
            clientPrintDetailsEmail:'',// this.clientPrintDetailsEmail ? this.clientPrintDetailsEmail: '',
            differentBillingEmail: this.differentBillingEmail ? this.differentBillingEmail : false,
            differentBillingAddress: this.differentBillingAddress ? this.differentBillingAddress : false,
            billingAddress:this.billingAddress,
            billingPostalCode:this.billingPostalCode,
            billingCity:this.billingCity,
            billingCountry:this.billingCountry,
            salesperson:this.user.uid,
            latestOrderDate,
          }
          
          if(this.selectedExistingOrderId === "") {
            if (!this.existingCompanySelected) companyData.totalOrders = 1
            else if(this.existingCompanySelected && this.companies[this.selectedCompanyId] && this.companies[this.selectedCompanyId].totalOrders) companyData.totalOrders = this.companies[this.selectedCompanyId].totalOrders + 1
            else if(this.existingCompanySelected && this.companies[this.selectedCompanyId] && !this.companies[this.selectedCompanyId].totalOrders) companyData.totalOrders = 1
          }

          if (!this.existingCompanySelected) {
              companyDBId = await this.$store.dispatch('company/set', companyData)
          }
          else {
              companyDBId = this.selectedCompanyId
              this.$store.dispatch('company/set', {id:companyDBId, ...companyData})
          }
          //console.log(companyData)
          
          var contactData = {
            companyId:companyDBId,
            firstName:this.firstName,
            lastName:this.lastName,
            phone:this.clientPhone ? this.clientPhone : '',
            language:this.language ? this.language : 'fi',
            email:this.clientEmail ? this.clientEmail : '',
            clientPrintDetailsEmail: this.clientPrintDetailsEmail ? this.clientPrintDetailsEmail: '',
            sendDraftsToSalesperson:this.sendDraftsToSalesperson ? true: false,
            sendConfirmation: this.sendConfirmation,
            doNotSendConfirmation:this.doNotSendConfirmation,
            doNotSendMaterialRequestEmail:this.doNotSendMaterialRequestEmail,
            comments:this.additionalCustomerInformation ? this.additionalCustomerInformation : '',
          }

          if (!this.existingContactSelected) { 
            contactDBId = await this.$store.dispatch('contact/set', contactData)
          }
          else {
            contactDBId = this.selectedContactId
            //console.log(contactData)
            //console.log(contactDBId)
            await this.$store.dispatch('contact/set', {id:contactDBId, ...contactData})
          }

          var responsible = this.staff[this.user.uid].orderResponsibility ? this.staff[this.user.uid].orderResponsibility : ""
          
          var isSampleOrder = this.typeOfOrder === 'sample' ? true : false
          var deliveryCharge = isSampleOrder ? 0 : this.deliveryCharges
          
          var orderId = "" 
          if(this.selectedExistingOrderId === "") {
            orderId = await this.$store.dispatch('order/set', {
                invoicesAllPaid:false,  
                orderStatus:'new',
                sample:isSampleOrder,
                contactId:contactDBId,
                deliveryCharge,
                deliveryBySalesperson:this.deliveryBySalesperson ? true : false,
                isAmendmentOrder:this.isAmendmentOrder ? true : false,
                splitInvoice:this.splitInvoice ? true : false,
                companyId:companyDBId,
                knownOperator:this.knownOperator,
                deliveryWeek:this.selectedDeliveryWeek,
                salesperson:this.user.uid,
                orderComments: this.orderComments,
                referenceOption: this.referenceOption,
                referenceText: this.referenceText,
                billingReferenceDetails: this.billingReferenceDetails,
                orderResponsible:responsible,
                salespersonMargin:"",
                sendOrderCommentsInConfirmation:this.sendOrderCommentsInConfirmation ? true : false
            })
          }
          else {
            orderId = this.selectedExistingOrderId
            await this.$store.dispatch('order/set', {
                id:orderId,
                invoicesAllPaid:false,
                orderStatus:'new',
                sample:isSampleOrder,
                contactId:contactDBId,
                deliveryCharge,
                deliveryBySalesperson:this.deliveryBySalesperson ? true : false,
                isAmendmentOrder:this.isAmendmentOrder ? true : false,
                splitInvoice: this.splitInvoice ? true : false,
                companyId:companyDBId,
                deliveryWeek:this.selectedDeliveryWeek,
                salesperson:this.user.uid,
                orderComments: this.orderComments,
                referenceOption: this.referenceOption,
                referenceText: this.referenceText,
                billingReferenceDetails: this.billingReferenceDetails,
                orderResponsible:responsible,
                salespersonMargin:"",
                sendOrderCommentsInConfirmation:this.sendOrderCommentsInConfirmation ? true : false
            })
          }

          var store = this.$store
          this.orderSummary = ""
          this.orderSummaryIds = ""
          this.selectedSamplePackageProductVariations = []
          var opId = ""
          var opIds = []
          var deadline = false
          if(isSampleOrder){
            var productVariation = null
            for (var i = 0; i < this.samplePackages[this.selectedSamplePackage].productVariations.length; i++) { 
              productVariation = this.samplePackages[this.selectedSamplePackage].productVariations[i]
              var pvId = productVariation.productVariationId
              if (pvId !== undefined && pvId !== '' && this.productVariations[pvId] !== undefined){
                this.selectedSamplePackageProductVariations.push(pvId)  
                var isWarehousedProduct = this.productVariations[pvId].warehoused ? true : false
                var productId = this.productVariations[pvId].productId
                var color = this.productVariations[pvId].color
                var size = this.productVariations[pvId].size
                var other = this.productVariations[pvId].other
                var name = this.products[productId].name.fi
                this.orderSummary += name 
                color !== undefined && color !== "" ? this.orderSummary += " " + color : ""
                size !== undefined && size !== "" ? this.orderSummary += " " + size : ""
                other !== undefined && other !== "" ? this.orderSummary += " " + other : ""
                this.orderSummary += " x 1; "
                //this.orderSummaryIds += pvId + " " + this.productVariations[pvId].sku + ";"
                
                opId = await store.dispatch('orderedProduct/set', {
                  productId:productId,
                  productVariationId:pvId,
                  isWarehousedProduct,
                  salesperson:this.user.uid,
                  customerProductName: name,
                  quantity:0,
                  numberOfSamples:1,
                  unitPrice:0,
                  unitPrintPrice:0,
                  orderId,
                  orderStatus:'new',
                  whenToInvoice:'',
                  orderInvoiceStatus:'doNotInvoice',
                  printQuantity:0,
                  printCostComments:'',
                  print: false,
                  printFormats:[],
                  newPrintOptionsInUse:false,
                  printOptions:[],
                  printOptionsSettings:{},
                  printFormatsText:'',
                  numberOfPrintColors:'',
                  printColor:'',
                  printLocation:'',
                  printContent:'',
                  printComments:'',
                  latestToCustomer:'',
                  numberOfPositionings:0,
                  pricePerPositioning:0,
                })
                opIds.push(opId)
              }
            }
          }
          else if(!isSampleOrder){
            var product = null
            for (var i = 0; i < this.newOrderProducts.length; i++) { 
              product = this.newOrderProducts[i]
              this.orderSummary += product.productName + " x " +product.quantity + ";"
              var opId = ""
              if (product.productId.trim() !== "") {
                //this.orderSummaryIds += product.productVariationId + " " + this.productVariations[product.productVariationId].sku + ";"
                
                var isWarehousedProduct = this.productVariations[product.productVariationId] && this.productVariations[product.productVariationId].warehoused ? true : false
                opId =  await store.dispatch('orderedProduct/set', {
                  sample:product.sample ? product.sample : false,
                  productId:product.productId,
                  productVariationId:product.productVariationId,
                  isWarehousedProduct,
                  salesperson:this.user.uid,
                  customerProductName: product.customerProductName,
                  quantity:product.quantity,
                  numberOfSamples:product.numberOfSamples,
                  unitPrice:product.unitPrice,
                  unitPrintPrice: product.unitPrintPrice ? product.unitPrintPrice : 0,
                  orderId,
                  orderStatus:'new',
                  whenToInvoiceSetManually:product.whenToInvoice ? true : false,
                  whenToInvoice:product.whenToInvoice,
                  orderInvoiceStatus:'doNotInvoice',
                  printQuantity:product.printQuantity,
                  printCostComments:product.printCostComments,
                  print: product.print,
                  secondPrint: product.secondPrint,
                  newPrintOptionsInUse:product.newPrintOptionsInUse ? true : false,
                  printOptions:product.printOptions ? product.printOptions : [],
                  printOptions2:product.printOptions2 ? product.printOptions2 : [],
                  printFormats:product.printFormats,
                  printFormats2:product.printFormats2,
                  printOptionsSettings:product.printOptionsSettings ? product.printOptionsSettings : {},
                  printOptionsSettings2:product.printOptionsSettings2 ? product.printOptionsSettings2 : {},
                  printFormatsText:product.printFormatsText,
                  numberOfPrintColors:product.numberOfPrintColors ? product.numberOfPrintColors : '',
                  numberOfPrintColors2:product.numberOfPrintColors2 ? product.numberOfPrintColors2 : '',
                  printColor: product.printColor,
                  printLocation: product.printLocation,
                  printContent: product.printContent,
                  printComments: product.printComments,
                  printColor2: product.printColor2,
                  printLocation2: product.printLocation2,
                  printContent2: product.printContent2,
                  printComments2: product.printComments2,
                  latestToCustomer: product.latestToCustomer,
                  numberOfPositionings: product.numberOfPositionings ? product.numberOfPositionings : 0,
                  pricePerPositioning:product.pricePerPositioning,
                })
                
                opIds.push(opId)
                if (product.latestToCustomer) deadline = true
                
              }
            }
          }
          this.$store.dispatch('order/set', {
              id:orderId,
              orderSummaryIds:this.orderSummaryIds,
              orderSummary:this.orderSummary,
              deadline
          })
          var s = this.staff[this.user.uid]
          if(s && s.email){
            await this.timer(1000);
            console.log("SENDING EMAIL 1")
            await this.$store.dispatch('sendMessageServerSide', {
              toEmail:s.email,
              fromEmail:s.email,
              customer:false,
              opIds,
              companyId:companyDBId,
              contactId:contactDBId,
              orderId,
              typeOfSend:'order_confirmation',
              dontShowSending:true
            })
            
            if(!this.doNotSendConfirmation && this.clientEmail){
              await this.timer(800);
              console.log("SENDING EMAIL 2")
              await this.$store.dispatch('sendMessageServerSide', {
                toEmail:this.clientEmail,
                fromEmail:s.email,
                customer:true,
                opIds,
                companyId:companyDBId,
                contactId:contactDBId,
                orderId,
                typeOfSend:'order_confirmation',
                dontShowSending:true
              })
            }
            if(!this.doNotSendMaterialRequestEmail && this.clientEmail){
              await this.timer(800);
              console.log("SENDING EMAIL 3")
              await this.$store.dispatch('sendMessageServerSide', {
                toEmail:this.clientEmail,
                fromEmail:s.email,
                customer:true,
                opIds,
                companyId:companyDBId,
                contactId:contactDBId,
                orderId,
                typeOfSend:'material_request',
                dontShowSending:true
              })
            }
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:5000, snackText:"Tilaus tallennettu.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          }
        }
        catch(e){
          var message = e.message
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Tallennuksessa/viestin lähetyksessä virhe: " +message+ ".", snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/NewOrder.vue